import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_16: FaireProductEntity = {
  token: "starter_collection_16",
  type: "product",
  name: "Hickory Stripe Tea Towels",
  brandName: "Atelier Saucier",
  imageUrl: "",
  priceDollars: 42,
  msrpDollars: 84,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
